module.exports = __webpack_public_path__ + "img/result_img_pass.b49752ad.png";